/* eslint-disable react/require-default-props */
import React from 'react';
import { func, oneOf, string } from 'prop-types';
import { GLOBAL } from '../../Config/global';
import './styles.scss';

const { MODAL } = GLOBAL;
function ConfirmationModal({
  icon = 'bi bi-exclamation-circle',
  status = 'primary',
  onConfirm,
  onDismiss,
  onCancel,
  message = MODAL.BODY,
  title = MODAL.TITLE
}) {
  const handleClose = () => {
    if (onCancel) {
      onCancel();
    } else if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header border-0 justify-content-end">
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
            />
          </div>

          <div className="modal-body text-center">
            {status === 'warning' && (
              <div className="mb-3">
                <i className={icon} style={{ fontSize: '3rem', color: '#ffc107' }}></i>
              </div>
            )}

            <h5 className="modal-title mb-3">{title}</h5>
            <p className="text-secondary">{message}</p>
          </div>

          <div className="modal-footer border-0 d-flex justify-content-center gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onDismiss}
            >
              {MODAL.CANCEL_BUTTON}
            </button>

            <button
              type="button"
              className={`btn btn-${status}`}
              onClick={onConfirm}
            >
              {MODAL.CONFIRM_BUTTON}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ConfirmationModal.propTypes = {
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
  onCancel: func,
  message: string,
  title: string,
  status: oneOf(['primary', 'warning', 'error', 'success']),
  icon: string
};

export default ConfirmationModal;